'use strict';
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const trackingUtils = require('od-modules/utils/tracking.utils');

module.exports = withRenderedMain(BaseView.extend({
    initialize: function() {
        this.$el.find(this.selectors.accountBlockedBody).html(this.prepareBodyText());
    },

    selectors: {
        accountBlockedLoginUser: '.account_blocked_login_user',
        accountBlockedGoHome: '.account_blocked_go_home',
        accountBlockedBody: '.account_blocked_body',
        loginNameEmpty: '.login_name_empty',
    },

    events: {
        'tap .account_blocked_login_user': 'onTapLoginUser',
        'tap .account_blocked_go_home': 'onTapGoHome',
    },

    prepareBodyText: function() {
        const loginName = !Odigeo._.isEmpty(Odigeo.UserArea.loginName) ? Odigeo.UserArea.loginName : Odigeo.Session.get('loginDetails');
        const textParam = '<span class="od-login-blocked-address not_user">' + loginName + '</span>';
        const textMobileParam = '<div class="od-login-message-text-email  not_user">' + loginName + '</div>';
        const isMobile = Odigeo.SessionScope.flow === 'mobile';

        return Odigeo.Utils.replaceCmsKeyArgs(this.keys.loginBlockedBodyMessage, isMobile ? textMobileParam : textParam);
    },

    onTapLoginUser: function(e) {
        e.stopPropagation();
        Odigeo.trigger(this.id + ':openLoginForm');
        // Analytics: event tracking
        trackingUtils.trackEventWithCategory('sso_blocked', 'sso_blocked', 'go_to_login');
    },

    onTapGoHome: function(e) {
        e.stopPropagation();
        Odigeo.Utils.goToApplicationHome();
    },
}));
